import { Outlet } from "react-router-dom"
import Navbar from "./shared/components/Navbar"
import SupportWidget from "./features/support/SupportWidget"

export const Wrapper = () => {
    return (
        <>
            <Navbar />
            <Outlet />
            <SupportWidget />
        </>
    )
}
